import React from "react";
import SortingDropdown from "../sortingDropdown";
import "./productDropdown.css"
import { ButtonGroup } from "react-bootstrap";

const ProductDropdown: React.FC<{
  selectedValue: string;
  items: { [key: string]: string };
  onSelected: (val: string) => void;
}> = (props) => {
  return (
    <>
      <section className="sorting-panel-container sorting-mobile">
        <div className="panel sorting-panel-default">
          <div className="sorting-panel-sorting-heading">
            <a className="panel-title">Sort by</a>
          </div>
          <div className="panel-body category-page-sorting">
            <SortingDropdown
              selectedValue={props.selectedValue}
              items={props.items}
              onSelected={props.onSelected}
            />
          </div>
        </div>
      </section>
      <section className="sorting-fullscreen">
        <span className="category-page-sorting">
          <span className="sorting-label">Sort by</span>
          <SortingDropdown
              selectedValue={props.selectedValue}
              items={props.items}
              onSelected={props.onSelected}
              elementType={ButtonGroup}
            />
        </span>
      </section>
    </>
  );
};

export default ProductDropdown;
